import { JSX, createContext, useContext, useEffect, useState } from "react";

import LinearProgress from "@mui/material/LinearProgress";

interface EnvConfig {
  ENVIRONMENT: string;
}

const EnvContext = createContext<EnvConfig | undefined>(undefined);

export function EnvProvider({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  const [config, setConfig] = useState<EnvConfig | undefined>(undefined);

  useEffect(() => {
    fetch("./env.json")
      .then((res) => res.json())
      .then((data: EnvConfig) => setConfig(data))
      .catch((err) => {
        console.error("Failed to load env.json", err);
      });
  }, []);

  if (!config) {
    return <LinearProgress />;
  }

  return <EnvContext.Provider value={config}>{children}</EnvContext.Provider>;
}

export function useEnvContext(): EnvConfig {
  const context = useContext(EnvContext);
  if (!context) {
    throw new Error("useEnvContext must be used within an EnvProvider");
  }
  return context;
}
